import {
  email,
  maxLength,
  minLength,
  object,
  pipe,
  string,
  trim,
} from "valibot";
import * as m from "~/paraglide/messages.js";

// Message callbacks (not strings) so valibot resolves them lazily at validation
// time — picking up the active Paraglide locale per request/render. Baking the
// string in at module load would freeze it to whichever locale loaded first.
export const contactSchema = object({
  email: pipe(
    string(),
    email(() => m.contact_error_email_invalid())
  ),
  // A sentence, not two characters. The old floor let "ok" through, which is
  // not a message anyone can reply to, and it prevented nothing.
  message: pipe(
    string(),
    trim(),
    minLength(20, () => m.contact_error_message_min()),
    maxLength(1000, () => m.contact_error_message_max())
  ),
});
